import {Component, OnInit, Input} from '@angular/core';
import { SpinnerService } from '../../../services';
import { Subscription }   from 'rxjs/Subscription';

@Component({
  selector: 'unco-spinner',
  templateUrl: 'spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {

  private subscription: Subscription;
  private showFlag: boolean;
  private softsubscription: Subscription;
  private showSoftFlag: boolean;

  constructor(private spinnerService: SpinnerService) {
    this.subscription = spinnerService.showFlag$.subscribe(flag => this.showFlag = flag);
    this.subscription = spinnerService.showSoftFlag$.subscribe(flag => this.showSoftFlag = flag);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/spinner/spinner.component.ts